import { RG_TYPE, deepFlatChildren } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel, addOpeningOnPivot } from "@project-rouge/rg-three";
function addExitDoorsToCores({ building, dataset }) {
  const rvData = dataset.rvData;
  const doorId = dataset.modulousIds.entranceDoorId;
  const groundCores = getRgObjectsAtLevel(building, RG_TYPE.Core, 0);
  const needExit = groundCores.filter((c) => c.data.hasExit);
  for (const core of needExit) {
    const floorHeight = Math.max(...deepFlatChildren(core).filter((c) => c.type === RG_TYPE.Floor).map((f) => f.pos[1]));
    const heightPivot = (floorHeight + core.anchor[1] * core.size[1]) / core.size[1];
    addOpeningOnPivot({ obj: core, type: RG_TYPE.Door, pivot: [0.5, heightPivot, 1], rvDataList: rvData, modulousId: doorId });
  }
}
export {
  addExitDoorsToCores
};
//# sourceMappingURL=index29.js.map
